/**
 * Zásady zpracování osobních údajů (GDPR) — hash-route #gdpr.
 * Správce = provozovatel areálu STALAGMIT, a.s. (údaje shodné s patičkou).
 */

const BLOCKS: { title: string; body: React.ReactNode }[] = [
  {
    title: '1. Správce osobních údajů',
    body: (
      <p>
        Správcem osobních údajů je <b>STALAGMIT, a.s.</b>, IČ 27377342, DIČ CZ27377342,
        se sídlem Varšavská 715/36, 120 00 Praha 2, provozovatel Sportovního areálu
        Sobáčov (Sobáčov 111, 783 21 Mladeč). Kontakt:{' '}
        <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
          rezervace.sobacov@gmail.com
        </a>, tel. +420 775 140 705.
      </p>
    ),
  },
  {
    title: '2. Jaké údaje zpracováváme a proč',
    body: (
      <ul className="list-disc list-inside space-y-2">
        <li>
          <b>Rezervace ubytování a sportovišť</b> — jméno a příjmení, telefon, e-mail,
          údaje o pobytu/termínu a platbě. Právní titul: plnění smlouvy (čl. 6 odst. 1
          písm. b GDPR) a plnění zákonných povinností (účetnictví, ubytovací evidence).
        </li>
        <li>
          <b>Kontaktní formulář a poptávky</b> — jméno, telefon, e-mail, obsah zprávy.
          Právní titul: jednání o smlouvě / oprávněný zájem na vyřízení dotazu.
        </li>
        <li>
          <b>Přihláška na brigádu</b> — jméno, telefon, e-mail; volitelně údaje pro
          dohodu o provedení práce (datum narození, rodné číslo, adresa, bankovní účet,
          zdravotní pojišťovna). Právní titul: jednání o uzavření pracovněprávního
          vztahu a plnění zákonných povinností zaměstnavatele.
        </li>
        <li>
          <b>Rybářské povolenky</b> — jméno a kontakt při vystavení povolenky na místě.
          Právní titul: plnění smlouvy a provozní evidence.
        </li>
      </ul>
    ),
  },
  {
    title: '3. Komu údaje předáváme',
    body: (
      <p>
        Údaje zpracováváme sami. Předáváme je pouze: platební bráně při online platbě
        (v rozsahu nutném pro provedení platby), účetní kanceláři správce, a orgánům
        veřejné moci, pokud to ukládá zákon (např. ubytovací evidence, finanční
        správa, ČSSZ a zdravotní pojišťovny u brigádníků). Údaje nepředáváme do třetích
        zemí ani je nevyužíváme k automatizovanému rozhodování či profilování.
      </p>
    ),
  },
  {
    title: '4. Jak dlouho údaje uchováváme',
    body: (
      <ul className="list-disc list-inside space-y-2">
        <li>rezervace a platby — po dobu trvání smlouvy a dále dle zákonných lhůt (účetní a daňové doklady až 10 let),</li>
        <li>poptávky a dotazy — po dobu vyřízení, nejdéle 1 rok od poslední komunikace,</li>
        <li>přihlášky na brigádu — po dobu náboru; u uzavřených dohod dle zákonných lhůt pro pracovněprávní a mzdovou agendu,</li>
        <li>záznamy o povolenkách — dle provozní a účetní evidence.</li>
      </ul>
    ),
  },
  {
    title: '5. Cookies a web',
    body: (
      <p>
        Web nepoužívá analytické, marketingové ani jiné nepovinné cookies a bez vašeho kliknutí
        neposílá žádné údaje třetím stranám (písma máme na vlastním serveru). Mapa Google v sekci
        Kontakt se načte až po kliknutí na „Zobrazit mapu“ — teprve tehdy Google zpracuje vaši
        IP adresu a může uložit vlastní soubory podle svých zásad. Platba kartou probíhá na stránce
        platební brány Comgate podle jejích podmínek.
      </p>
    ),
  },
  {
    title: '6. Vaše práva',
    body: (
      <p>
        Máte právo na přístup ke svým údajům, jejich opravu či výmaz, omezení
        zpracování, přenositelnost a právo vznést námitku. Uplatníte je e-mailem na{' '}
        <a href="mailto:rezervace.sobacov@gmail.com" className="font-semibold text-ink-900 hover:text-brand-600">
          rezervace.sobacov@gmail.com
        </a>. Pokud se domníváte, že zpracování odporuje právním předpisům, můžete podat
        stížnost u Úřadu pro ochranu osobních údajů (www.uoou.gov.cz).
      </p>
    ),
  },
]

export function Gdpr() {
  return (
    <section className="bg-paper py-12 md:py-20 min-h-screen">
      <div className="container-x max-w-3xl">
        <p className="h-eyebrow">Důležité info</p>
        <h1 className="h-display text-3xl md:text-[40px] mt-4">
          Zásady zpracování osobních údajů
        </h1>
        <p className="mt-5 text-ink-700">
          Ochrana osobních údajů podle nařízení (EU) 2016/679 (GDPR) a zákona
          č. 110/2019 Sb., o zpracování osobních údajů.
        </p>

        <div className="mt-10 space-y-8">
          {BLOCKS.map((b) => (
            <div key={b.title} className="card p-6 md:p-7">
              <h2 className="font-bold text-lg text-ink-900 tracking-tight">{b.title}</h2>
              <div className="mt-3 text-[15px] text-ink-800 leading-relaxed">{b.body}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-[13px] text-ink-700">
          Tyto zásady jsou účinné od 4. 8. 2026.
        </div>

        <a href="#top" onClick={() => { window.location.hash = ''; }} className="btn-outline-dark mt-8">
          Zpět na hlavní stránku
        </a>
      </div>
    </section>
  )
}
